import { Button } from '@/components/Button'
import { BRANDSIDE_SERVICE_URL } from '@/config/site'
import { MKTU_CLASS_CATEGORY_TITLE } from '@/models/Mktu'
import { Word } from '@/domains/Account/modules/Mktu/components/Word'
import { onlineSearchStore } from '@/shared/OnlineSearch/store/OnlineSearch.store'
import { MktuClassStore } from '@/store/Mktu/MktuClass'
import cn from 'classnames'
import React, { CSSProperties, FC, useEffect, useMemo } from 'react'
import styles from './MktuClassDescriptionPopup.module.scss'

type MktuClassDescriptionPopupProps = {
  mktuClassStore: MktuClassStore
  isVisible?: boolean
  style: CSSProperties
  ref: React.Ref<HTMLDivElement>
  registrationNumber?: string
}
export const MktuClassDescriptionPopup: FC<MktuClassDescriptionPopupProps> = ({
  mktuClassStore,
  isVisible,
  style,
  ref,
  registrationNumber,
}) => {
  const toLkButtonLInk = useMemo(
    () =>
      registrationNumber
        ? `${
            BRANDSIDE_SERVICE_URL ?? ''
          }/registries/TM/TM-RUTM${registrationNumber}`
        : onlineSearchStore.registryInfo?.registrationNumber
        ? `${BRANDSIDE_SERVICE_URL ?? ''}/registries/TM/TM-RUTM${
            onlineSearchStore.registryInfo.registrationNumber
          }`
        : '#',
    [registrationNumber]
  )

  useEffect(() => {
    mktuClassStore.getWords()
  }, [mktuClassStore])

  return (
    <div
      className={cn(styles.tooltip, {
        [styles.isVisible]: isVisible,
      })}
      style={style}
      ref={ref}
    >
      <div className={styles.tooltipHeader}>
        <div className={styles.tooltipTitle}>Класс {mktuClassStore.number}</div>
        <div className={styles.tooltipType}>
          {MKTU_CLASS_CATEGORY_TITLE[mktuClassStore.type]}
        </div>
      </div>
      <div className={styles.tooltipDescription}>
        {mktuClassStore.description}
      </div>
      {mktuClassStore.selectedWordsNames.length != 0 ? (
        <>
          <div className={styles.selectedWords}>
            {mktuClassStore.selectedWordsNames.slice(0, 1).map((word) => (
              <Word
                maxWidth={412}
                className={styles.word}
                key={word}
                name={word}
                id={word}
                isNice={
                  mktuClassStore.words.find((w) => w.word === word)?.isNice ??
                  false
                }
                isDeletable={false}
              />
            ))}

            {mktuClassStore.selectedWordsNames.length > 1 ? (
              <div className={styles.moreWords}>
                +{mktuClassStore.selectedWordsNames.length - 1}
              </div>
            ) : null}
          </div>
        </>
      ) : null}
      <Button
        href={toLkButtonLInk}
        target="_blank"
        className={styles.toLkButton}
      >
        Полный перечень в Личном Кабинете
      </Button>
    </div>
  )
}
